import { render, staticRenderFns } from "./proofView.v2.vue?vue&type=template&id=2d99a58c&scoped=true&"
import script from "./proofView.v2.vue?vue&type=script&lang=js&"
export * from "./proofView.v2.vue?vue&type=script&lang=js&"
import style0 from "./proofView.v2.vue?vue&type=style&index=0&id=2d99a58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99a58c",
  null
  
)

export default component.exports